/* global debug */
/*
 * MarkerInfoWindow handles all the logic for opening and closing Infoboxes.
 * It also manages the content of the infobox and all it needs is a marker.
 * This plugin also listens for any changes such as clicking on a marker,
 * selecting a row from the advanced mode table, or the drawing selector.
 * When the selection changes it takes care of the infobox status.
 */
(function () {
  var MarkerInfoWindow = function () {
    var self = this;

    var init = function () {
      //add listeners when the plugin loads;
      BatchGeoStore.addListener(
        function (state) {
          return state.RowSelect.selection;
        },
        // We can just check if the rows have changed
        function (nextSelectedRows, prevSelectedRows) {
          return nextSelectedRows.toString() != prevSelectedRows.toString();
        },
        // Row selection has change...
        function (newRows, prevRows) {
          BatchGeoStore.dispatch([
            {
              type: "OPTIMAL_ROUTE_GROUP_CURRENT_ROW_UPDATE",
              currentRows: newRows,
            },
            {
              type: "OPTIMAL_ROUTE_GROUP_PREVIOUS_ROW_UPDATE",
              previousRows: prevRows,
            },
          ]);

          var shouldOpenInfoWindow =
            !BatchGeoStore.getState().DrawingManager.currentlySelecting;
          if (newRows.length == 1 && !BatchGeoDevices.is("mobile")) {
            //When a row gets selected, just dispatch the marker click event
            //this will take care of opening and closing any other infowindow
            //as well as open the infowindow for this row if needed.
            var lastClickedMarker =
              BatchGeoStore.getState().MapsMarkersManager.clickedMarker;
            if (shouldOpenInfoWindow) {
              if (
                lastClickedMarker == null ||
                lastClickedMarker.r != newRows[0]
              ) {
                BatchGeoStore.dispatch({
                  type: "MAPSMARKERS_MANAGER_MARKER_CLICKED",
                  marker: self.getMarker(newRows[0]),
                });
              }
            }
          }
        },
      );

      BatchGeoStore.addListener(
        "DrawingManager",
        "selection",
        function (markerIds, prevMarkerIds) {
          self.MarkerInfoWindow._handleOpeningOfMarkersFromDrawer(
            markerIds,
            prevMarkerIds,
          );
        },
      );
    };

    var _handleOpeningOfMarkersFromDrawer = function (newRows, _prevRows) {
      // It's important that this is the markers OBJECT not the array. The
      // object creates an `{id: marker, ...}` pairing whereas the array is
      // simply [marker, ...]. This means where you try to pass the marker with
      // something like `markers[newRows[0]]` it can select the wrong marker
      // because markers are only markers, meaning, geocoded data. So if you're
      // missing a location [a,b,c] becomes, [a,c]. So if you did markers[2]
      // it'd fail because b doesnt exist. However, if you use the object
      // method it will because itll look it up by the key
      var markers = self.getMarkersAsObject();
      //if the selection is just one row, then open it. If there is another infowindw
      //already oppened, it will take care of it. No need to call close()
      if (newRows.length == 1) {
        return self.MarkerInfoWindow._openPointWin(markers[newRows[0]]);
      }
    };

    /**
     * This is the function that gets called when opening a marker
     * from anywhere in the app. Just call window.batchGeoGoogleMarker.openMarker(marker)
     * @param  {object} marker The marker instance for the infobox you want to open
     * @return {undefined}
     */
    var _openPointWin = function (marker) {
      const openedInfoWindows =
        BatchGeoStore.getState().MapsMarkersManager.openedInfoWindows;

      //Dont try to open an info window on a heatmap
      var isHeatmapEnabled = window.BatchGeoStore.getState().HeatMap.enabled;
      if (isHeatmapEnabled) {
        return;
      }

      // skip if already open
      if (
        !openedInfoWindows.some(
          (openedInfoWindow) => openedInfoWindow.id === marker.id,
        )
      ) {
        var map = window.batchGeoGoogleMapsManager.getMap();
        // TODO(tom) I can't fidn this defined anywhere but test code, is that right?
        if (debug) {
          BatchGeo.timer("openPointWin() trigger ");
        }

        if (typeof marker == "number") {
          marker = self.getMarker(marker);
        }

        if (!marker) {
          return;
        }

        var markers = self.getMarkersObjArray();
        if (marker.map === undefined) {
          // expose markers hidden in clusters
          if (window.clarker) {
            window.clarker.removeMarker(marker);
          }

          if (window.per.map_render_type.type !== "choropleth") {
            marker.setMap(map);
          }
        }
        if (marker.urlCoords === undefined) {
          // marker not fully created yet
          markers[marker.r].marker = self.MarkerContent.createMapMarker(
            markers[marker.r].marker,
            marker.r,
          );
        }

        if (map.getZoom() >= 20) {
          map.setZoom(18);
        }

        var upperArrow = '<div class="infowindow-upper-arrow"></div>';

        // added to refresh contents on click
        var infoContents = self.MarkerContent.createMarkerText(
          marker.textOptions,
          { useImage: window.per.use_descIMG },
        );
        var infobox = self.MarkerInfoWindow._createInfoBox(
          marker.id,
          upperArrow +
            infoContents +
            window.BatchGeoInfoWindowPage(
              marker.r,
              function (paginationCluster) {
                BatchGeoStore.dispatch({
                  type: "MAPSMARKERS_MANAGER_INFOWINDOW_PAGINATION_CLUSTER",
                  paginationCluster: paginationCluster,
                });
              },
            ),
        );

        self.MarkerInfoWindow._openInfoWindow(infobox, marker);
      }
    };

    var closeInfoWindows = function () {
      const state = BatchGeoStore.getState();
      const mapsMarkersManager = state.MapsMarkersManager;

      if (mapsMarkersManager.openedInfoWindows) {
        mapsMarkersManager.openedInfoWindows.forEach((openInfoWindow) => {
          if (!openInfoWindow.infoWindow.pinned_) {
            openInfoWindow.infoWindow.close();
          }
        });
      }

      if (state.RowSelect.selection.length <= 1) {
        self.MarkerResizer.zoomOut(state.MapsMarkersManager.lastOpenedMarker);
      }
    };

    var _openInfoWindow = function (infowindow, clickedMarker) {
      closeInfoWindows();

      BatchGeoStore.dispatch({
        type: "MAPSMARKERS_MANAGER_INFOWINDOW_OPEN",
        id: clickedMarker.id,
        infoWindow: infowindow,
        marker: clickedMarker,
      });

      if (debug) BatchGeo.timer("openInfoWindow() trigger ");

      infowindow.open(window.batchGeoGoogleMapsManager.getMap(), clickedMarker);

      //activates marker
      self.MarkerResizer.zoomIn(clickedMarker);

      google.maps.event.addListenerOnce(infowindow, "domready", function () {
        // Once InfoWindow has been rendered to DOM, add hover event listeners
        // to allow for scrollable actions when mouseover the .infoBox
        // and still allow for zoom scroll when mouseout of the infobox element.

        //sync selected marker/row when ready
        if (window.batchGeoTableMap?.batchGeoTable?.RowSelect) {
          var rowSelect = window.batchGeoTableMap.batchGeoTable.RowSelect;

          //if marker was clicked to open, row would already be set
          //we dont want to select the row twice

          //confirm we have a clicked marker
          if (clickedMarker && clickedMarker.id >= 0) {
            //check if the row has been identified by the click handler
            if (!rowSelect.isRowSelected(clickedMarker.id)) {
              //select single row
              rowSelect.select([clickedMarker.id], { fromMarkerClick: false });
            }
          }
        }

        var map = window.batchGeoGoogleMapsManager.getMap();
        var $infobox = $(infowindow.div_);
        var $markerContent = $infobox.find(".markerSub");

        window.BatchGeoInfoWindowPageEvents();
        window.BatchGeoInfoWindowCreateAddress(
          clickedMarker,
          function (address) {
            $infobox.find("#markerAddress").html(address);
          },
        );

        // Get current scrollwheel bool to set after mouseout event
        var defaultState = map.scrollwheel;

        // Check if content is scrollable, if so, apply event listener
        // This prevents disabling of zoom with there is no scroll
        if ($markerContent.length) {
          // Since this doesn't load until the marker is clicked it's not included in
          // the lazyload array so we set the src attribute, to make the image load
          var $markerImg = $markerContent.find(".lazy");
          $markerImg.attr("src", $markerImg.data("src"));

          if ($markerContent[0].clientHeight >= 400) {
            $markerContent.on("mouseover", function () {
              map.setOptions({ scrollwheel: false });
            });
            $markerContent.on("mouseout", function () {
              map.setOptions({ scrollwheel: defaultState });
            });
          }
        }
        //adjust the url in the info window
        let addressBoxVal =
          $("#addressBox").val() || $(".storeLocator-search-input").val() || "";

        addressBoxVal = addressBoxVal.replace(/ *\([^)]*\) */g, "");
        if (addressBoxVal.length > 0) {
          let origin = "&origin=" + addressBoxVal;
          let path =
            "https://www.google.com/maps/dir/?api=1&destination=" +
            clickedMarker.urlCoords +
            origin;
          $("#navigation-button")[0].href = path;
        }
      });
    };

    /**
     * Returns the dimensions of an infobox based on the content given by adding the
     * content virtually so we can determine what the sizing will be
     *
     * @param  {string} content the text to put inside of the infobox. Accepts HTML.
     * @return {array} An array containing the width/height like [100,200]
     */
    var getInfoBoxDimensions = function (content) {
      var parent = $("<div>").addClass("infoBox");
      var sensor = $("<div>").html(content);
      $(sensor).appendTo(parent);
      $(parent).appendTo("body").css({ position: "absolute", left: "-999px" });
      var width = $(sensor).width();
      var height = $(sensor).height();
      $(parent).remove();
      return new Array(width, height);
    };

    /**
     * Creates and returns a new InfoBox instance containing the content given
     *
     * @param  {string} content the text to put inside of the infobox. Accepts HTML.
     * @return {object} A new InfoBox instance
     */
    var _createInfoBox = function (id, content) {
      var infoBoxDimensions = getInfoBoxDimensions(content);

      if (BatchGeoDevices.is("phone")) {
        if (BatchGeoStore.getState().App.isMap) {
          return BatchGeoMobileInfoWindow.init($("body"));
        } else {
          return new window.InfoBox({
            id: id,
            content: content,
            disableAutoPan: false,
            alignBottom: false,
            pixelOffset: new google.maps.Size(
              -parseInt(infoBoxDimensions[0] / 2 + 5),
              { circle: 8, square: -4, pushpin: -2 }[
                self.options.markersData.shape
              ],
            ),
            zIndex: null,
            contextmenu: true,
            enableEventPropagation: false,
            boxStyle: {
              opacity: 1,
              zIndex: 999,
              width: infoBoxDimensions[0],
            },
            closeBoxMargin: ".5em 4px 2px 2px",
            closeBoxURL: self.options.baseURL + "/images/icons/clear.png",
            visible: true,
            infoBoxClearance: new google.maps.Size(1, 1),
          });
        }
      } else {
        return new window.InfoBox({
          id: id,
          content: content,
          disableAutoPan: false,
          alignBottom: false,
          pixelOffset: new google.maps.Size(
            -parseInt(infoBoxDimensions[0] / 2 + 5),
            { circle: 8, square: -4, pushpin: -2 }[
              self.options.markersData.shape
            ],
          ),
          zIndex: null,
          contextmenu: true,
          enableEventPropagation: false,
          boxStyle: {
            opacity: 1,
            zIndex: 999,
            width: infoBoxDimensions[0],
          },
          closeBoxMargin: ".5em 4px 2px 2px",
          closeBoxURL: self.options.baseURL + "/images/icons/clear.png",
          visible: true,
          infoBoxClearance: new google.maps.Size(1, 1),
        });
      }
    };

    /**
     * Handles positioning the map based on the coords of a marker and then opening
     * the infobox window for that row. It uses a row ID not a marker and lets you
     * decide to zoom into the marker or not and if you want to wait until all
     * panning and movement is done before opening the infobox.
     *
     * @param {number} row The marker ID. Used to open and center the infoboxes
     * @param {boolean} zoomIn If true the map will zoom into the marker location
     * @param {boolean} delay If true it will zoom and/or open the infobox instantly
     * and won't wait for panning and zooming to be done
     * @return {undefined}
     */
    var smoothOpenMarker = function (row, zoomIn, delay) {
      zoomIn = typeof zoomIn !== "undefined" ? zoomIn : false;
      delay = typeof delay !== "undefined" ? delay : true;

      var zoomFunc = function () {
        if (zoomIn) {
          window.batchGeoGoogleMapsManager.map.setZoom(13);
          google.maps.event.addListenerOnce(
            window.batchGeoGoogleMapsManager.map,
            "idle",
            function () {
              self.MarkerInfoWindow._openPointWin(
                self.getMarkersObjArray()[row].marker,
              );
            },
          );
        } else {
          self.MarkerInfoWindow._openPointWin(
            self.getMarkersObjArray()[row].marker,
          );
        }
      };

      window.batchGeoGoogleMapsManager.map.setCenter(
        self.getMarkersObjArray()[row].marker.getPosition(),
      );

      if (delay)
        google.maps.event.addListenerOnce(
          window.batchGeoGoogleMapsManager.map,
          "idle",
          zoomFunc,
        );
      // wait till map pan is done then open infowindow
      else zoomFunc();
    };
    var forceClose = function (markerId) {
      const state = BatchGeoStore.getState();
      const mapsMarkersManager = state.MapsMarkersManager;
      if (mapsMarkersManager.openedInfoWindows) {
        var openWindow = mapsMarkersManager.openedInfoWindows.find(
          (managedWindow) => managedWindow.id === markerId,
        );

        if (openWindow) {
          openWindow.infoWindow.pinned_ = false;
          openWindow.infoWindow.close();
        }
      }
    };
    var toggleInfoWindow = function () {
      var lastMarker =
        BatchGeoStore.getState().MapsMarkersManager.lastOpenedMarker;
      self.MarkerInfoWindow._openPointWin(lastMarker);
    };

    init();
    // Public API
    self.MarkerInfoWindow = {
      open: _openPointWin,
      smoothOpenMarker: smoothOpenMarker,
      close: closeInfoWindows,
      forceClose: forceClose,
      toggleInfoWindow: toggleInfoWindow,
      _openPointWin: _openPointWin,
      _handleOpeningOfMarkersFromDrawer: _handleOpeningOfMarkersFromDrawer,
      _openInfoWindow: _openInfoWindow,
      _createInfoBox: _createInfoBox,
    };
  };

  window.MarkerInfoWindow = MarkerInfoWindow;
})(window);
